import { profileStore } from "../../hooks/profile";
import React, { useEffect } from "react";
import Constants from "../../helper/Constants";
import System from "../../helper/system";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";

const AvnetContactInformation = () => {
    const [{ profile_account_information }, { get_profile_account_information }] = profileStore();
    const { siteUser: { WEB, CORE } } = Constants;
    const { avUserInfoData: { currentUser } } = System
    const [__check] = useAxiosIndicatorCheck();
    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }

        if (Object.keys(profile_account_information).length <= 0) {
            fetchHere();
        }
    }, [profile_account_information]);

    return (
        <>{__check("PROFILE_ACCOUNT_INFORMATION").status ? __check('PROFILE_ACCOUNT_INFORMATION').render :
            <>
                {currentUser === WEB && <div className='my-contact-webuser text-center'>
                    <p className='font-arial font-16 text-black mb-0'>
                        <strong>{profile_account_information.contacts?.[0]?.contactName}</strong></p>
                    <p className='font-arial font-16 text-black mb-0 mt-1 d-flex align-items-center justify-content-center'>
                        <i className="fa fa-phone me-2"
                            aria-hidden="true"></i>{profile_account_information.contacts?.[0]?.contactNumber}</p>
                    <p className='mt-1 d-flex align-items-center justify-content-center'><i
                        className="fa fa-envelope me-2"
                        aria-hidden="true"></i>
                        <u><a href={`mailto:${profile_account_information.contacts?.[0]?.email}`}
                            className='text-blue2 font-16'>{profile_account_information.contacts?.[0]?.email}</a></u>
                    </p>
                </div>}
                {currentUser === CORE && <div className='my-contact-coreuser'>
                    {profile_account_information?.contacts?.map((contact, i) => {
                        return <div key={i} className='contact-card-column'>
                            <div className='contact-card'>
                                <div className='font-arial font-16 text-black mb-0 contact-role'>{contact.title}</div>
                                <div className="contact-name font-13 text-black">{contact.contactName}</div>
                                {contact.contactNumber?.trim() &&
                                    <div className="contact-phone font-13 text-black">PH: {contact.contactNumber}</div>}
                                <div className="contact-email font-13"><a href={`mailto:${contact.email}`}
                                    className='text-blue2'>{contact.email}</a>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
                }
            </>
        }
        </>
    );
}
export default AvnetContactInformation;